export default __webpack_public_path__ + "static/media/Haunted_Memory_16_9.ae0ef0e9.png";